import * as ACTIONS from 'constant/actions/licence-management'
import initialState from './initial-state'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.LICENCE_MANAGEMENT_GET_CUSTOMER_LICENCES + '_PENDING':
      state = {
        ...state,
        loading: true,
        refreshLicences: false
      }
      break
    case ACTIONS.LICENCE_MANAGEMENT_GET_CUSTOMER_LICENCES + '_REJECTED':
      state = {
        ...state,
        loading: false,
        refreshLicences: true
      }
      break
    case ACTIONS.LICENCE_MANAGEMENT_GET_CUSTOMER_LICENCES + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          licences: {
            ...state.licences,
            [action.payload.data.cimn]: action.payload.data.licences
          },
          loading: false,
          refreshLicences: false
        }
      }
      break
    case ACTIONS.LICENCE_MANAGEMENT_ADD_CUSTOMER_LICENCE + '_FULFILLED':
      state = {
        ...state,
        refreshLicences: true
      }
      break
    case ACTIONS.LICENCE_MANAGEMENT_UPDATE_LICENCE_REVOKED:
      state = {
        ...state,
        stateChanged: !state.stateChanged
      }
      const licenceIndexPending = state.licences[action.plcimn].findIndex(licence => licence.PLMN === Number(action.plmn))

      state.licences[action.plcimn][licenceIndexPending].PLRevoked = action.revoked
      break
    case ACTIONS.LICENCE_MANAGEMENT_UPDATE_LICENCE_REVOKED + '_FULFILLED':
      const licenceIndex = state.licences[action.payload.data.plcimn].findIndex(licence => licence.PLMN === Number(action.payload.data.plmn))

      state = {
        ...state,
        stateChanged: !state.stateChanged
      }

      state.licences[action.payload.data.plcimn][licenceIndex].PLRevoked = action.payload.data.revoked === 'true'
      break
  }
  return state
}
